var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-grid"},_vm._l((_vm.groups),function(group,index){return _c('mobile-menu-group',{key:index,attrs:{"id":group.TabIdName,"header-text":group.headerText,"items":group.items},on:{"feedback":function($event){return _vm.increaseFeedbackModalKey()}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }